import styled from 'styled-components';

export const SubTitle = styled.h3`
    font-size: 1.7rem;
    font-weight: 600;
`;

export const StyledMainList = styled.div`
    margin: 0.5rem 0 2.0rem 0;
`;